export enum OttokartLeadsWorkspaceCapabilityAccessOperation {
    create = "e0bdf75d-e6b0-4fbe-af84-ef1d22e399b2",
    read = "363baa25-b691-4bab-8cfb-0950e50ab54d",
    update = "c56d46ad-aff9-4667-b77d-18942d068f90",
    delete = "26465749-c708-4615-853e-68e73a988da7",
}
